module.exports = __webpack_public_path__ + "2b0a857a1134873dda6c943af132cd4e.png";